import { useMemo } from 'react';
export const useIconColor = ({ variant, textColor, fetching, disabled, loading, }) => {
    const iconColor = useMemo(() => {
        if (!variant || !textColor)
            return textColor;
        return {
            primary: (() => {
                if (disabled)
                    return 'neutral-400';
                return textColor;
            })(),
            outlined: (() => {
                if (disabled)
                    return 'neutral-400';
                if (loading || fetching)
                    return textColor;
                return 'primary-500';
            })(),
        }[variant];
    }, [variant, textColor, loading, fetching, disabled]);
    return iconColor;
};
